export const ACTION_CODE = 'TRAINING_OBJECTIVE' + '_ACTION';
